import React, { useState, useEffect } from 'react';
import { Snackbar } from '@material-ui/core';
import { Check, AlertCircle } from 'tabler-icons-react';
import { CalidadProvider, useCalidad } from './CalidadContext';
import PartesDefectos from './PartesDefectos';
import CausasRaiz from './CausasRaiz';
import '../../styles/capacidades.css';
import '../../styles/calidad.css';
import '../../styles/notifications.css';
import '../../App.css';

const TABS = [
    { key: 'partes', label: 'Partes y defectos' },
    { key: 'causas', label: 'Causa raíz' },
];

function Calidad() {
    const { cargarTodo, snackbar, setSnackbar, snackbarText, snackbarError } = useCalidad();
    const [tab, setTab] = useState('partes');

    useEffect(() => {
        cargarTodo();
    }, [cargarTodo]);

    const handleSnackClose = (_, reason) => {
        if (reason === 'clickaway') return;
        setSnackbar(false);
    };

    return (
        <div className="capacidadesView">
            <Snackbar
                open={snackbar}
                autoHideDuration={3000}
                onClose={handleSnackClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <div className={`app-notif ${snackbarError ? 'app-notif--error' : 'app-notif--success'}`}>
                    {snackbarError ? (
                        <AlertCircle size={20} strokeWidth={2} color="#fff" />
                    ) : (
                        <Check size={20} strokeWidth={2} color="#fff" />
                    )}
                    <span className="app-notif__msg">{snackbarText}</span>
                    <div className="app-notif__progress" />
                </div>
            </Snackbar>

            <div className="capacidadesView-head">
                <h1 className="titulo">Calidad</h1>
                <p className="desc">
                    Administra las causas raíz y la relación entre partes y tipos de defecto.
                </p>
                <div className="cal-tabs">
                    {TABS.map((t) => (
                        <button
                            key={t.key}
                            className={`cal-tab${tab === t.key ? ' cal-tab--active' : ''}`}
                            onClick={() => setTab(t.key)}
                        >
                            {t.label}
                        </button>
                    ))}
                </div>
            </div>

            <div className="capacidadesView-body">
                {tab === 'partes' ? <PartesDefectos /> : <CausasRaiz />}
            </div>
        </div>
    );
}

export default function CalidadPage() {
    return (
        <CalidadProvider>
            <Calidad />
        </CalidadProvider>
    );
}
